/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_VanInputs */

const vi_vehicle_type_van = /** @type {(inputs: Vehicle_Type_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe van`)
};

/**

* @param {Vehicle_Type_VanInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_van = /** @type {((inputs?: Vehicle_Type_VanInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_VanInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_type_van(inputs)
});